import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Event } from '../../../../models/event.model';
import { InitialsPipe } from '../../../../pipes/initials.pipe';
import { MomentPipe } from '../../../../pipes/moment.pipe';
import { DeviceService } from '../../../../services/device.service';
import { EventService } from '../../../../services/event.service';
import { AppOpenBannerComponent } from '../../../components/app-open-banner/app-open-banner.component';

@Component({
  selector: 'app-event-invite',
  standalone: true,
  imports: [AppOpenBannerComponent, InitialsPipe, MomentPipe],
  templateUrl: './event-invite.component.html',
  styleUrl: './event-invite.component.css',
})
export class EventInviteComponent {
  private eventService = inject(EventService);
  private device = inject(DeviceService);
  private route: ActivatedRoute = inject(ActivatedRoute);

  eventId: string | null = null;
  event: Event | null | undefined;

  loading = true;
  /** True once we know the event can't be shown here - e.g. an anonymous
   *  visitor (Firestore rules require the reader to at least be signed in),
   *  a non-member, or a bad/deleted eventId. We still show a generic invite
   *  card and the app hand-off rather than an error page. */
  loadFailed = false;

  constructor() {
    this.route.queryParamMap.subscribe((params) => {
      this.eventId = params.get('eventId');
      if (this.eventId) this.loadEvent();
    });
  }

  get appDeepLinkPath(): string {
    return this.eventId
      ? `links/eventinvite?eventId=${this.eventId}`
      : 'links/eventinvite';
  }

  loadEvent(): void {
    this.eventService.getEventById(this.eventId!).subscribe({
      next: (event) => {
        this.event = event;
        this.loading = false;
      },
      error: (err) => {
        console.warn('EventInviteComponent :: loadEvent notice:', err);
        this.loadFailed = true;
        this.loading = false;
      },
    });
  }

  openInApp(): void {
    this.device.openApp(this.appDeepLinkPath);
  }
}
